import React from 'react';
import { HowStep } from '../../types/howItWorks';
import { cadenceStyles } from './cadenceStyles';
interface FlowRailProps {
  steps: HowStep[];
  onJump: (id: string) => void;
}
export function FlowRail({
  steps,
  onJump
}: FlowRailProps) {
  return <nav aria-label="Commission steps" className="overflow-x-auto rounded border border-sf-border bg-white px-2 py-2 shadow-card" data-id="element-306" data-mp="1h1oo81e02tgj">
      <ol className="flex min-w-max items-center lg:min-w-0" data-id="element-307" data-mp="182tmb1hzo5j1">
        {steps.map((step, index) => <li key={step.id} className="flex min-w-0 flex-1 items-center" data-id="element-308" data-mp="133gyadfdssev" data-mpi={index}>
            <button type="button" onClick={() => onJump(step.id)} className="flex min-w-0 flex-1 items-center gap-2 rounded px-2 py-1.5 text-left transition-colors duration-150 ease-out hover:bg-sf-bg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sf-blue" data-id="element-309" data-mp="136cv1yfhtb1q">
              <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white ${cadenceStyles[step.cadence].solid}`} data-id="element-310" data-mp="2oh37jmqxpe5n">
                {step.number}
              </span>
              <span className="whitespace-nowrap text-xs font-semibold text-sf-text" data-id="element-311" data-mp="20h3euh1n53b1">{step.shortTitle}</span>
            </button>
            {index < steps.length - 1 && <span className="h-px w-3 shrink-0 bg-sf-border-strong" aria-hidden="true" data-id="element-312" data-mp="1qhw13sqzv6ne" />}
          </li>)}
      </ol>
    </nav>;
}